module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/star_disabled-c7bbb4cc0eca4fb7826d2d73d0d6d7a1.svg";